<template>
  <div class="attachments-info">
    <b-row>
      <b-col
        v-if="attachments.length"
        class="mt-2"
      >
        <patient-downloable-attachment
          :attachments="attachments"
          :patient-id="patientId"
          @deleteAttachment="onDeleteAttachment"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import patientAttachmentService from '@/api/resources/attachment/patientAttachmentService'
import PatientDownloableAttachment from '@/components/searcherPatientModal/PatientDownloableAttachment'
export default {
    name: 'PatientAttachmentsInfo',
    components: {
        PatientDownloableAttachment
    },
    props: {
        patientId: { type: Number, required: true }
    },
    data() {
        return {
            attachments: []
        }
    },
    async created() {
        await this.getAttachments()
    },
    methods: {
        async getAttachments() {
            const [err, response] = await this.toCall(patientAttachmentService.getAttachments(this.patientId))
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            this.attachments = response
        },
        onDeleteAttachment(removedAttachmentId) {
            this.attachments.forEach((attachment, index, attachments) => {
                if (attachment.attachmentId === removedAttachmentId) {
                    attachments.splice(index, 1)
                }
            })
            this.$emit('onDeleteAttachment', this.attachments.length)
        }
    }
}

</script>
